import { VisitorType } from "@/types/all.types";
import { nanoid as nanoidNonSecure } from "nanoid/non-secure";
import { nanoid as nanoidSecure } from "nanoid";
import { DEBUGGER } from "./helper";

type VisitorParams = {
  version: string;
  visitorToken: string | null;
  queryParams: string | null;
};

// 477 status code if payload is empty for visitor log
export function getVisitorLog(visitiorParams: VisitorParams) {
  try {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    const currentVisitorToken = visitiorParams.visitorToken || nanoidSecure(35) || nanoidNonSecure(35);
    let collectedData = {
      ...params,
      referer: document.referrer || "",
      link: window.location.pathname,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      version: visitiorParams.version,
    } as VisitorType;
    collectedData = {
      ...collectedData,
      ...handleQueryParams(params, visitiorParams.queryParams),
      token: currentVisitorToken,
    };
    return { collectedData, currentVisitorToken };
  } catch (err) {
    DEBUGGER("error Query Params data => ", err);
    return { currentVisitorToken: null };
  }
}

function handleQueryParams(params: any, userQueryParams: string | null) {
  if (
    userQueryParams &&
    (JSON.parse(userQueryParams).gclid ||
      JSON.parse(userQueryParams).keyword ||
      JSON.parse(userQueryParams).AdId ||
      JSON.parse(userQueryParams).matchtype ||
      JSON.parse(userQueryParams).device ||
      JSON.parse(userQueryParams).devicemodel ||
      JSON.parse(userQueryParams).loc ||
      JSON.parse(userQueryParams).network ||
      JSON.parse(userQueryParams).campaignid ||
      JSON.parse(userQueryParams).place ||
      JSON.parse(userQueryParams).utm_source)
  ) {
    const gclid = params?.gclid || JSON.parse(userQueryParams).gclid;
    const keyword = params?.keyword || JSON.parse(userQueryParams).keyword;
    const AdId = params?.AdId || JSON.parse(userQueryParams).AdId;
    const matchtype = params?.matchtype || JSON.parse(userQueryParams).matchtype;
    const device = params?.device || JSON.parse(userQueryParams).device;
    const devicemodel = params?.devicemodel || JSON.parse(userQueryParams).devicemodel;
    const loc = params?.loc || JSON.parse(userQueryParams).loc;
    const network = params?.network || JSON.parse(userQueryParams).network;
    const place = params?.place || JSON.parse(userQueryParams).place;
    const campaignid = params?.campaignid || JSON.parse(userQueryParams).campaignid;
    const utm_source = params?.utm_source || JSON.parse(userQueryParams).utm_source;
    return {
      gclid,
      keyword,
      AdId,
      matchtype,
      device,
      devicemodel,
      loc,
      network,
      campaignid,
      place,
      utm_source,
    };
  }
}
